/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 16:21:13
 * @LastEditors: liuziwei
 * @Description: 券浮层壳子
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="drawer-frame-container">
    <es-drawer-bottom
      show="{{open}}"
      title="{{cusTitle}}"
      defaultNavLeft="{{leftTitle}}"
      customStyle="{{containerStyle}}"
      bind:close="closeDrawer"
    >
      <!-- 自定义左侧标题 -->
      <view slot="left" wx:if="{{leftTitle}}" class="left-title">{{ title }}
        <slot name="titleSlot" />
      </view>
      <!-- 内容部分 -->
      <slot></slot>
    </es-drawer-bottom>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      // drawer 开关
      open: {
        type: Boolean,
        value: () => false
      },
      // 默认的居中标题文本
      title: {
        type: String,
        value: () => ''
      },
      // 将标题位置置于左侧
      leftTitle: {
        type: Boolean,
        value: () => false
      },
      // 自定义容器样式
      customStyle: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // 自定义居中标题
      cusTitle() {
        return this.leftTitle ? '' : this.title
      },
      // 自定义容器样式
      containerStyle() {
        return Object.assign(
          {
            height: 'auto',
            overflow: 'hidden',
            maxHeight: '70vh'
          },
          this.customStyle
        )
      }
    },
    methods: {
      // 关闭券浮层
      closeDrawer() {
        // 上报事件
        this.triggerEvent('closeDrawer')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .left-title
    font-family PingFang SC
    font-size 19px
    font-weight 500
    line-height 23px
    display flex
    align-items center
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom'
    }
  }
</script>
